export const formatInterestsToBE = interests => {
  return interests.map(item => ({
    id: item.value,
    name: item.label
  }))
}

export const formatBehaviorsToBE = interests => {
  return interests.map(item => ({
    id: item.value,
    name: item.label
  }))
}
